// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__280pq","left":"styles_left__1JY-n","desktopActions":"styles_desktopActions__3FLQV","title":"styles_title__2RPjn"};